import React from "react";

import "../App.css";

const Skeleton = () => {
  return (
    <div className="st-blog-list-section st-content-lg-wrap">
      <div className="container">
        <div className="st-case-study-first-wrap">
          <div className="row">
            <div className="col-xl-6 col-lg-7 col-12">
              <div className="skeleton-loading animate-pulse skeleton-hero-image"></div>
            </div>
            <div className="col-xl-6 col-lg-5 col-12 align-self-end">
              <div className="st-case-study-content-wrap">
                <div className="skeleton-loading animate-pulse skeleton-title"></div>
                <div className="skeleton-loading animate-pulse skeleton-description"></div>
                <div className="skeleton-loading animate-pulse skeleton-content"></div>
                <div className="skeleton-loading animate-pulse skeleton-button"></div>
              </div>
            </div>
          </div>
        </div>
        <section className="st-case-study-grid-section">
          <div className="row">
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <div key={item} className="st-case-study-list-wrapper col-lg-4 col-12 mt-2">
                <div className="st-case-study-list-inner">
                  <div className="skeleton-loading animate-pulse skeleton-card-image"></div>
                  <div className="st-case-study-list-content-wrap">
                    <div className="skeleton-loading animate-pulse skeleton-card-title"></div>
                    <div className="skeleton-loading animate-pulse skeleton-card-description"></div>
                    <div className="skeleton-loading animate-pulse skeleton-card-meta"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Skeleton;
